import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanApplicationId,
  getLoanApplicationState,
  getFlowState,
  getOccupationSelectOptions,
  getEmploymentTypeSelectOptions,
  getLoanApplication
} from '../reducers';

import {
  loanApplicationUserGobackStart,
  loanApplicationUserGotoStart,
} from '../actions';

import Applicants from './steps/Applicants'
import Financials from './steps/Financials'
import Income from './steps/Incomes'
import Expenses from './steps/Expenses'
import Commitments from './steps/Commitments'
import Assets from './steps/Assets'
import LoanSetup from './steps/LoanSetup'
import Profile from './steps/Profile'
import LoanSummary from './steps/LoanSummary'
import Employment from './steps/Employment'
import Declarations from './steps/Declarations'
import Review from './steps/Review'
import ConfirmApproval from './steps/ConfirmApproval'
import ReadyForFinal from './steps/ReadyForFinal'

class Form extends React.Component {
  state = {
    isExpenseStep1: true,
  }

  // add action loanApplicationGoBackStart
  // saga listed to action
  // on success updates the redux-store and rerender
  // on failure sweetalert props to retry and catch it into sentry
  onGoBackClick = () => {
    this.props.loanApplicationUserGobackStart({
      loanApplicationId: this.props.loanApplicationId
    })
  }

  onGoToClick = (state) => {
    this.props.loanApplicationUserGotoStart({
      flow_state: state
    })
  }

  renderFlowStep() {
    let {
      flowState,
      availableOccupations,
      availableEmploymentTypes,
      loanApplication
    } = this.props

    switch (flowState) {
      case 'financials':
        return(<Financials />)
      case 'income':
        return(
          <Income
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.primaryApplicantName}
            currentApplicant={"primary"}
          />
        )
      case 'secondary_income':
        return(
          <Income
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.secondaryApplicantName}
            currentApplicant={"secondary"}
          />
        )
      case 'expenses':
        return(
          <Expenses
            flowState={flowState}
            onGoBackClick={this.onGoBackClick}
          />
        )
      case 'expenses_2':
        return(
          <Expenses
            flowState={flowState}
            onGoBackClick={this.onGoBackClick}
          />
        )
      case 'commitments':
        return(<Commitments
                onGoBackClick={ this.onGoBackClick }
              />)
      case 'assets':
        return(<Assets
                onGoBackClick={ this.onGoBackClick }
              />)
      case 'loan_setup':
        return(<LoanSetup
                onGoBackClick={ this.onGoBackClick }
              />)
      case 'loan_summary':
        return(<LoanSummary
                onGoBackClick={ this.onGoBackClick }
              />)
      case 'personal_details':
        return(
          <Profile
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.primaryApplicantName}
            currentApplicant={"primary"}
          />
        )
      case 'secondary_personal_details':
        return(
          <Profile
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.secondaryApplicantName}
            currentApplicant={"secondary"}
          />
        )
      case 'employment':
        return(<Employment
            availableOccupations={ availableOccupations }
            availableEmploymentType={ availableEmploymentTypes }
            currentApplicant={"primary"}
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.primaryApplicantName}
            />)
      case 'secondary_employment':
        return(<Employment
            availableOccupations={ availableOccupations }
            availableEmploymentType={ availableEmploymentTypes }
            currentApplicant={"secondary"}
            onGoBackClick={ this.onGoBackClick }
            name={loanApplication.secondaryApplicantName}
            />)
      case 'declarations':
        return(<Declarations onGoBackClick={ this.onGoBackClick }/>)
      case 'review':
        return(<Review onGoToClick={ this.onGoToClick }/>)
      case 'ready_for_final':
        return(<ReadyForFinal />)
      case 'confirm_approval':
        return(<ConfirmApproval />)
      default:
        return null;
    }
  }

  renderCurrentStep() {
    let { loanApplicationState } = this.props

    switch (loanApplicationState) {
      case 'pending':
        return(<Applicants />)
      default:
        return(this.renderFlowStep())
    }
  }

  render() {
    return(
      <div className="container product-container">
        <br />
        <br />
        { this.renderCurrentStep() }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  loanApplicationId: getLoanApplicationId(state),
  loanApplicationState: getLoanApplicationState(state),
  flowState: getFlowState(state),
  availableOccupations: getOccupationSelectOptions(state),
  availableEmploymentTypes: getEmploymentTypeSelectOptions(state),
  loanApplication: getLoanApplication(state),
})

export default connect(mapStateToProps, {
  loanApplicationUserGobackStart,
  loanApplicationUserGotoStart
})(Form);
